import * as actions from './actions';
import reducer from './reducers';
import * as selectors from './selectors';
import NAMESPACE from './types';

export {
    actions,
    selectors,
};

export default {
    [NAMESPACE]: reducer,
};
